import request from '@/utils/request'

// crm 首页
export function adminSystemIndex(data) {
  return request({
    url: 'setting/index',
    method: 'post',
    data: data
	
  })
}

// crm 首页保存
export function adminSystemSave(data) {
  return request({
    url: 'setting/save',
    method: 'post',
    data: data,
	headers: {
		'Content-Type': 'multipart/form-data'
	}
  })
}

// crm 公海设置
export function adminCustomerseas(data) {
  return request({
    url: 'crm/setting/customerseas',
    method: 'post',
    data: data
  })
}

// crm 公海设置保存
export function adminCustomerseasSave(data) {
  return request({
    url: 'crm/setting/customerseassave',
    method: 'post',
    data: data
  })
}

// 获取角色权限列表
export function getRoleauthList(data) {
  return request({
    url: 'setting/groupindex',
    method: 'post',
    data
  })
}

// 获取角色员工列表
export function getRoleuserList(data) {
  return request({
    url: 'setting/roleuserlist',
    method: 'post',
    data
  })
}

// 新建角色信息
export function roleAdd(data) {
  return request({
    url: 'setting/savegroup',
    method: 'post',
    data
  })
}

// 修改角色信息
export function roleUpdate(data) {
  return request({
    url: 'setting/updategroup',
    method: 'post',
    data: data
  })
}

// 修改角色权限
export function roleRulesUpdate(data) {
  return request({
    url: 'setting/updateRole',
    method: 'post',
    data: data
  })
}

// 删除角色信息
export function roleDel(data) {
  return request({
    url: 'setting/delgroup',
    method: 'post',
    data: data
  })
}

// 删除角色关联员工
export function roleUsersDel(data) {
  return request({
    url: 'setting/roleUsersDel',
    method: 'post',
    data: data
  })
}

// 获取角色权限列表
export function rulesList(data) {
  return request({
    url: 'setting/rulelist',
    method: 'post',
    data
  })
}

// 角色关联员工
export function roleUsers(data) {
  return request({
    url: 'setting/ruleusers',
    method: 'post',
    data
  })
}

// 获取部门非树形列表
export function adminStructuresListDialog(data) {
  return request({
    url: 'setting/deplist',
    method: 'post',
    data: data
  })
}

// 获取部门树形列表
export function depTreeList() {
  return request({
    url: 'setting/deplist',
    method: 'post',
    data: {
      type: 'tree'
    }
  })
}

// 新增部门
export function depSave(data) {
  return request({
    url: 'setting/depsave',
    method: 'post',
    data: data
  })
}

// 修改部门
export function depEdit(data) {
  return request({
    url: 'setting/depupdate',
    method: 'post',
    data: data
  })
}

// 删除部门
export function depDelete(data) {
  return request({
    url: 'setting/depdel',
    method: 'post',
    data: data
  })
}

// 设置直属上级
export function setLeaderrequest(data) {
  return request({
    url: 'user/setLeader',
    method: 'post',
    data: data
  })
}

// 设置部门
export function setDeprequest(data) {
  return request({
    url: 'user/setDep',
    method: 'post',
    data: data
  })
}

// 设置角色
export function setRolerequest(data) {
  return request({
    url: 'user/setRole',
    method: 'post',
    data: data
  })
}

// 用户列表
export function adminUsersIndex(data) {
  return request({
    url: 'user/index',
    method: 'post',
    data: data
  })
}

// 新建用户
export function usersAdd(data) {
  return request({
    url: 'user/save',
    method: 'post',
    data: data
  })
}

// 修改用户
export function usersUpdate(data) {
  return request({
    url: 'user/update',
    method: 'post',
    data: data
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: 'user/resetPassword',
    method: 'post',
    data: data
  })
}

// 禁用账号
export function disable(data) {
  return request({
    url: 'user/disable',
    method: 'post',
    data: data
  })
}

// 启用账号
export function enables(data) {
  return request({
    url: 'user/enables',
    method: 'post',
    data: data
  })
}

// 自定义字段
export function diyfields(data) {
  return request({
    url: 'admin/field/index',
    method: 'post',
    data
  })
}

/** 自定义字段（字段数据）的详情 */
export function customFieldList(data) {
  return request({
    url: 'setting/readfield',
    method: 'post',
    data: data
  })
}

/** 自定义字段（字段数据）的添加编辑操作 */
export function customFieldHandle(data) {
  return request({
    url: 'setting/fieldupdate',
    method: 'post',
    data: data
  })
}

// 根据部门获取部门userid
export function getsubUserByDep(data) {
  return request({
    url: 'setting/getsubuser',
    method: 'post',
    data: data
  })
}

// 登录日志
export function getLoginLog(data) {
  return request({
    url: 'user/loginlog',
    method: 'post',
    data: data
  })
}

// 获取表格字段
export function filedGetField(data) {
  return request({
    url: 'field/getField',
    method: 'post',
    data: data
  })
}

// crm 自定义字段(高级筛选)
export function filterIndexfields(data) {
  return request({
    url: 'field/heightfields',
    method: 'post',
    data: data
  })
}

/** 客户保护规则*/
export function crmSettingConfigData(data) {
  return request({
    url: 'setting/configdata',
    method: 'post',
    data: data
  })
}

/** 客户保护规则*/
export function crmSettingConfig(data) {
  return request({
    url: 'setting/poolrule',
    method: 'post',
    data: data
  })
}

/**
 * 记录类型 数据
 * @param {*} data
 */
export function crmSettingRecordListAPI(data) {
  return request({
    url: 'setting/recordList',
    method: 'post',
    data: data
  })
}

/**
 * 记录类型 编辑
 * @param {*} data
 */
export function crmSettingRecordEditAPI(data) {
  return request({
    url: 'setting/recordedit',
    method: 'post',
    data: data
  })
}

/**
 * 拥有、锁定客户数限制
 * @param {*} data
 */
export function crmSettingCustomerConfigListAPI(data) {
  return request({
    url: 'setting/customerConfigList',
    method: 'post',
    data: data
  })
}

/**
 * 拥有、锁定客户数限制 - 创建
 * @param {*} data
 */
export function crmSettingCustomerConfigSaveAPI(data) {
  return request({
    url: 'setting/customerConfigSave',
    method: 'post',
    data: data
  })
}

/**
 * 拥有、锁定客户数限制 - 编辑
 * @param {*} data
 */
export function crmSettingCustomerConfigUpdateAPI(data) {
  return request({
    url: 'setting/customerConfigUpdate',
    method: 'post',
    data: data
  })
}

/**
 * 拥有、锁定客户数限制 - 删除
 * @param {*} data
 */
export function crmSettingCustomerConfigDelAPI(data) {
  return request({
    url: 'setting/customerConfigDel',
    method: 'post',
    data: data
  })
}

/** 自定义字段（字段数据）的列表更新时间 */
export function customFieldIndex(data) {
  return request({
    url: 'field/index',
    method: 'post',
    data: data
  })
}

/** 支付方式列表 */
export function crmSettingPayWayListAPI(data) {
  return request({
    url: 'setting/paywayList',
    method: 'post',
    data: data
  })
}


/** 支付方式修改 */
export function crmSettingPayWayEditAPI(data) {
  return request({
    url: 'setting/paywayedit',
    method: 'post',
    data: data
  })
}


/** 信息来源列表 */
export function crmSettingcustomerOriginListAPI(data) {
  return request({
    url: 'setting/customeroriginlist',
    method: 'post',
    data: data
  })
}


/** 信息来源修改 */
export function crmSettingcustomerOriginEditAPI(data) {
  return request({
    url: 'setting/customeroriginedit',
    method: 'post',
    data: data
  })
}

/** 案件类型列表 */
export function crmSettingcustomerTypeListAPI(data) {
  return request({
    url: 'setting/customertypelist',
    method: 'post',
    data: data
  })
}


/** 案件类型修改 */
export function crmSettingcustomerTypeEditAPI(data) {
  return request({
    url: 'setting/customertypeedit',
    method: 'post',
    data: data
  })
}

/** 非诉案件状态列表 */
export function crmSettingfeisuStatusListAPI(data) {
  return request({
    url: 'setting/feisustatuslist',
    method: 'post',
    data: data
  })
}


/** 非诉案件状态修改 */
export function crmSettingfeisuStatusEditAPI(data) {
  return request({
    url: 'setting/feisustatusedit',
    method: 'post',
    data: data
  })
}

/** 刑事案件状态列表 */
export function crmSettingxingshiStatusListAPI(data) {
  return request({
    url: 'setting/xingshistatuslist',
    method: 'post',
    data: data
  })
}


/** 刑事案件状态修改 */
export function crmSettingxingshiStatusEditAPI(data) {
  return request({
    url: 'setting/xingshistatusedit',
    method: 'post',
    data: data
  })
}

/** 诉讼案件状态列表 */
export function crmSettingsusongStatusListAPI(data) {
  return request({
    url: 'setting/susongstatuslist',
    method: 'post',
    data: data
  })
}


/** 诉讼案件状态修改 */
export function crmSettingsusongStatusEditAPI(data) {
  return request({
    url: 'setting/susongstatusedit',
    method: 'post',
    data: data
  })
}

/** 公告首页 */
export function crmGgIndexAPI(data) {
  return request({
    url: 'setting/gonggao',
    method: 'post',
    data: data
  })
}

/** 获取公告 */
export function crmGgGetoneAPI(data) {
  return request({
    url: 'setting/get_gonggao',
    method: 'post',
    data: data
  })
}

/** 新增公告 */
export function crmGgSaveAPI(data) {
  return request({
    url: 'setting/save_gonggao',
    method: 'post',
    data: data
  })
}

/** 修改公告 */
export function crmGgUpdateAPI(data) {
  return request({
    url: 'setting/update_gonggao',
    method: 'post',
    data: data
  })
}

/** 删除公告 */
export function crmGonggaoDel(data) {
  return request({
    url: 'setting/del_gonggao',
    method: 'post',
    data: data
  })
}

